import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { SessionService } from "../../services/session.service";
import { SessionWidgetService } from "../../services/session-widget.service";

export const querySession = createAsyncThunk(
  "sessionManage/querySessionByStaffId",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await SessionService.querySession(filter);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSession = createAsyncThunk(
  "sessionManage/addSession",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SessionService.addSession(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addSessionWidget = createAsyncThunk(
  "sessionManage/addSessionWidget",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SessionWidgetService.addSessionWidget(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editSession = createAsyncThunk(
  "sessionManage/editSession",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await SessionService.editSession(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editSessionWidget = createAsyncThunk(
  "sessionManage/editSessionWidget",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await SessionWidgetService.editSessionWidget(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const removeSession = createAsyncThunk(
  "sessionManage/removeSession",
  async (id, { rejectWithValue }) => {
    try {
      const response = await SessionService.removeSession(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readSession = createAsyncThunk(
  "sessionManage/readSession",
  async (id, { rejectWithValue }) => {
    try {
      const response = await SessionService.readSession(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readSessionWidget = createAsyncThunk(
  "sessionManage/readSessionWidget",
  async ({id, domain}, { rejectWithValue }) => {
    try {
      const response = await SessionWidgetService.readSessionWidget(id, domain);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const countSessionWaiting = createAsyncThunk(
  "sessionManage/countSessionWaiting",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await SessionService.countSessionWaiting();

      return _.get(response, "data", 0);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readSessionByRequesterId = createAsyncThunk(
  "sessionManage/readSessionByRequesterId",
  async (requesterId, { rejectWithValue }) => {
    try {
      const response = await SessionService.readSessionByRequesterId(
        requesterId
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const convertTicket = createAsyncThunk(
  "sessionManage/convertTicket",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await SessionService.convertTicket(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listSessionHistoryByRequester = createAsyncThunk(
  "sessionManage/listSessionHistoryByRequester",
  async (requesterId, { rejectWithValue }) => {
    try {
      const response = await SessionService.listSessionHistoryByRequester(
        requesterId
      );

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const reportChat = createAsyncThunk(
  "sessionManage/reportChat",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await SessionService.reportChat(filter);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const reportRating = createAsyncThunk(
  "sessionManage/reportRating",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await SessionService.reportRating(filter);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const reportStaff = createAsyncThunk(
  "sessionManage/reportStaff",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await SessionService.reportStaff(filter);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
